import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { isOverdue, isToday } from 'src/app/helper/general.helper';
import { MaterialModule } from 'src/app/material.module';
import { CustomDatePipe } from 'src/app/pipe/date-format.pipe';
import { TruncatePipe } from 'src/app/pipe/truncate.pipe';

@Component({
  selector: 'app-card-item',
  standalone: true,
  imports: [
    MaterialModule,
    CustomDatePipe,
    CommonModule,
    TruncatePipe,
    FormsModule
  ],
  templateUrl: './card-item.component.html',
  styleUrl: './card-item.component.scss',
})
export class CardItemComponent {
  data = input.required<any>();
  showFocus = input<boolean>(false);
  editAction = output<any>();
  deleteAction = output<any>();
  markCompletedAction = output<any>();

  editActivty(item) {
    this.editAction.emit(item);
  }

  onCheckboxChange(event: any) {
    event.source.checked = this.data().completed;
    this.markCompletedAction.emit({ ...this.data() });
  }

  onCheckboxClick(event: MouseEvent) {
    event.stopPropagation();
  }

  markCompleted() {
    this.markCompletedAction.emit({ ...this.data() });
  }

  deleteActivity(id) {
    this.deleteAction.emit(id);
  }

  isToday(date: Date): boolean {
    return isToday(date);
  }

  isOverdue(date: Date, allDay: boolean): boolean {
    return isOverdue(date, allDay);
  }

  // Get outcome from either direct property or nested appointment
  getOutcome(): any {
    return this.data()?.outcome || this.data()?.appointment?.outcome;
  }

  // Format status for display (NO_SHOW -> No Show)
  formatStatus(status: string): string {
    if (!status) return '';
    return status.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()).replace(/\bNo Show\b/i, 'No Show');
  }

  getStatusClass(status: string): string {
    if (!status) return '';
    const statusLower = status.toLowerCase();
    if (statusLower === 'show') return 'status-show';
    if (statusLower === 'no_show' || statusLower === 'no show') return 'status-no-show';
    if (statusLower.includes('cancel')) return 'status-cancel';
    if (statusLower === 'rescheduled' || statusLower === 'reschedule') return 'status-reschedule';
    if (statusLower === 'scheduled') return 'status-scheduled';
    return 'status-pending';
  }
}